import { useState } from 'react'

import { Features } from 'generated/featureDefinitions'
import { ExpensesPlanPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import ExpensesSubscriptionUsersDatatable from 'modules/expenses/components/subscription'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import AddUsersModal from './AddUsersModal'

const ExpensesPlanPage = () => {
  const { company } = useCurrentSession()
  const subscriptionId = company?.subscription?.id
  const { data, error } = useQuery(ExpensesPlanPageDocument, {
    variables: {
      featureIds: [Features.expenses_per_user_pricing_create_expenses],
      subscriptionId,
    },
    skip: !subscriptionId,
  })
  const [modalOpen, setModalOpen] = useState(false)
  const expensesPerUserPricingAvailable =
    data?.companies?.featureAvailabilitiesConnection.nodes.find(
      (f) => f.id == Features.expenses_per_user_pricing_create_expenses
    )?.available ?? false

  return (
    <ResponsivePage.Body
      loading={!data && !error}
      authorized={expensesPerUserPricingAvailable}
      error={error}
      header={{
        illustration: 'user-male-female',
        title: i18n.t('billing.subscription.plans.expenses.title'),
        description: i18n.t('billing.subscription.plans.expenses.description'),
      }}
    >
      <ExpensesSubscriptionUsersDatatable
        onAddPressed={() => setModalOpen(true)}
        managedByPartnersUserLimit={data?.billing.subscription?.expensesQuantityCeiling ?? 0}
      />
      {modalOpen && <AddUsersModal onClose={() => setModalOpen(false)} />}
    </ResponsivePage.Body>
  )
}

export default ExpensesPlanPage
